import gql from 'graphql-tag';

export default gql`
  fragment azureRecognizedPhraseNBestFragment on AzureRecognizedPhraseNBest {
    id
    displayText
  }
`;
